import { useRecoilState } from 'recoil'
import PageMasthead from '../components/PageMasthead'
import SimpleLoader from '../components/SimpleLoader'
import NoTeam from '../components/team/NoTeam'
import TeamDetails from '../components/team/TeamDetails'
import { userState } from '../store/DomainStore'
import { useTitle } from '../components/TitleProvider'
import { useGetUserTeamsAdminQuery } from '../api/client'

type Props = {}

function TeamPage(props: Props) {
    useTitle('Team details')
    const [user] = useRecoilState(userState)

    const { data: userTeamsData, loading: userTeamsLoading } = useGetUserTeamsAdminQuery({
        variables: { userId: user?.id || 0 },
        skip: !user
    })

    let display

    // A user should always be available at this point - but just in case show the loading spinner
    if (!user || userTeamsLoading) {
        display = (
            <div>
                <SimpleLoader loading={true} />
            </div>
        )
    }

    // Not all users are in a team so handle this scenario
    if (
        !userTeamsLoading &&
        userTeamsData?.getUserTeamsAdmin &&
        userTeamsData?.getUserTeamsAdmin.length === 0
    ) {
        display = <NoTeam />
    }

    // We have a team id so display the team details
    if (userTeamsData?.getUserTeamsAdmin && userTeamsData?.getUserTeamsAdmin.length > 0) {
        display = (
            <>
                {userTeamsData?.getUserTeamsAdmin.map((team) => {
                    return <TeamDetails key={team.id} team={team} />
                })}
            </>
        )
    }

    return (
        <div className="min-h-full bg-ink-50">
            <PageMasthead title="Team" subtitle="The colleagues you share Arwen with" />
            <div className="mx-auto w-full max-w-3xl space-y-6 px-4 py-6 sm:px-6 lg:px-8">
                {display}
            </div>
        </div>
    )
}

export default TeamPage
